import { Helmet } from "react-helmet-async";
import type { Article } from "@core/features/support";
import { StaticPage } from "@platform/features/staticPage";
import { SupportArticleNavigation } from "./SupportArticleNavigation";

export type Props = {
  article: Article;
  className?: string;
  prev?: Article | null;
  next?: Article | null;
  onNavigationClick: (article: Article) => void;
};

export function SupportArticle({
  article,
  className,
  prev,
  next,
  onNavigationClick,
}: Props) {
  return (
    <>
      <Helmet>
        <title>
          {["Pollinator", "Support", article.title].filter(Boolean).join(" | ")}
        </title>
      </Helmet>
      <StaticPage article={article} className={className} />
      <div className="flex flex-row justify-between mt-16 w-full px-4 md:pr-8 md:pl-0">
        <SupportArticleNavigation
          prev={prev ?? null}
          next={next ?? null}
          onClick={onNavigationClick}
        />
      </div>
    </>
  );
}

export default SupportArticle;

